// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__DTpfT","admin":"Menu_admin__INPUM"};